import {DESKTOP_MIN_WIDTH} from '../../constants/visuals';

// До этой ширины витрина квадратная; выше (но до десктопной раскладки) —
// вдвое ниже своей ширины: на планшетном экране квадрат во всю ширину
// вытеснил бы кнопки меню за пределы экрана
export const MENU_SHOWCASE_SQUARE_MAX_WIDTH = 768;

/**
 * Размер витрины главного меню на узких экранах — она стоит в потоке, на месте
 * бюста, и занимает всю ширину.
 *
 * Одна и та же геометрия нужна и самому блоку, и сцене Phaser: сцена
 * масштабируется в родителя с сохранением пропорций (Scale.FIT), поэтому при
 * расхождении поле легло бы узкой полосой по центру пустого блока. Отсюда
 * размер здесь считается в пикселях, а не задается media-запросами в CSS.
 *
 * @returns {{width: number, height: number} | null} null — десктопная
 *   раскладка, у нее своя область справа от панели меню
 */
export const getMenuShowcaseSize = () => {
  const width = window.innerWidth;
  if (width >= DESKTOP_MIN_WIDTH) {
    return null;
  }
  return {
    width,
    height: width <= MENU_SHOWCASE_SQUARE_MAX_WIDTH ? width : Math.round(width / 2),
  };
};

/**
 * Отпечаток раскладки витрины: пересобирать поле нужно, только когда меняется
 * он, а не любой resize окна.
 *
 * На телефоне высота окна прыгает на каждом скролле — браузер прячет и
 * показывает адресную строку, — а витрина там зависит ТОЛЬКО от ширины
 * (высота задана от нее же). Без этой проверки каждый скролл главного меню
 * пересобирал сцену: лоадер, перерисовка, потерянная секунда.
 *
 * @returns {string}
 */
export const getMenuShowcaseLayoutKey = () => {
  const size = getMenuShowcaseSize();
  if (size) {
    return `compact:${size.width}x${size.height}`;
  }
  // Десктопная витрина занимает всю область справа от панели меню — там
  // значимы обе стороны окна
  return `desktop:${window.innerWidth}x${window.innerHeight}`;
};
